/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Share: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M1 4V22C1 22.2652 1.10536 22.5196 1.29289 22.7071C1.48043 22.8946 1.73478 23 2 23H21C21.2652 23 21.5196 22.8946 21.7071 22.7071C21.8946 22.5196 22 22.2652 22 22V13H20V21H3V5H5V3H2C1.73478 3 1.48043 3.10536 1.29289 3.29289C1.10536 3.48043 1 3.73478 1 4Z'
      fill='currentColor'
    />
    <path d='M15 14V10C9.7 10 7.9 11.5 6 14C6 5.9 9.8 4 15 4V0L23 7L15 14Z' fill='currentColor' />
  </React.Fragment>
)
